export const DEFAULT_LOCATION = {
  streetInfo: '',
  city: '',
  state: '',
  postalCode: '',
  streetNumber: '',
  unitNumber: '',
  streetDirection: '-',
};
